import { useSyncExternalStore } from 'react';
import { subscribeToApiActivity, getActiveApiRequestCount } from '@/api/apiClient';

export function useActiveApiRequestCount(): number {
    return useSyncExternalStore(subscribeToApiActivity, getActiveApiRequestCount, getActiveApiRequestCount);
}
